import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb';
import { formatUnits } from '@/components/funds-carry/funds/carryFundValues';
import { CarryEntityHeader } from '@/components/funds-carry/structure/CarryEntityHeader';
import { CarryHoldingPositionsTable } from '@/components/funds-carry/structure/CarryHoldingPositionsTable';
import { PORTAL_CARRY_STRUCTURE_PATH } from '../carryPaths';
import { PortalStructureData } from '../components/structure/PortalStructureData';
import type { CarryHolding, CarryStructure } from '../services/carryService';

function HoldingDetail({
  structure,
  positions,
}: {
  structure: CarryStructure;
  positions: CarryHolding[];
}) {
  const { holding } = structure;
  if (!holding) {
    return (
      <p className="text-sm text-muted-foreground">
        You hold no carry through a holding company.
      </p>
    );
  }

  const totalUnits = positions.reduce((sum, p) => sum + p.units, 0);
  return (
    <div className="space-y-6">
      <PageBreadcrumb
        segments={[
          { label: 'Structure', href: PORTAL_CARRY_STRUCTURE_PATH },
          { label: holding.holding_name },
        ]}
      />
      <CarryEntityHeader
        kind="Personal holding company"
        title={holding.holding_name}
        description={`${structure.full_name} holds the carry rights directly through this company as a member of the cooperative.`}
        facts={[
          { label: 'CoC', value: holding.holding_coc_number ?? '—' },
          { label: 'Board', value: structure.full_name },
          { label: 'Units', value: `${formatUnits(totalUnits)} units` },
        ]}
      />
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Positions per fund</h3>
        <CarryHoldingPositionsTable positions={positions} />
      </div>
    </div>
  );
}

export function PortalCarryHoldingPage() {
  return (
    <PortalStructureData>
      {(structure, positions) => (
        <HoldingDetail structure={structure} positions={positions} />
      )}
    </PortalStructureData>
  );
}
